/*jshint esversion: 6 */
import Vue from 'vue';
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  loading: false,
  log_lists: {},
  error: ''
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getLoglists: ( state ) => (twork_package_id) => {
    return state.log_lists[twork_package_id];
  },
  getLoglist: ( state ) => (payload) => {
    return state.log_lists[payload.twork_package_id].find(log_list => log_list.id === payload.log_list_id);
  },
  isLoading: ( state ) => {
    return state.loading;
  }
};
// Actions
const actions = {
  requestLoglists({ commit }, payload){
    commit('log_list_loading', true);
    axios({
        url: 'projects/' +
        payload.project_id +
        '/trains/' +
        payload.train_id +
        '/taktareas/' +
        payload.taktarea_id +
        '/twaggons/' +
        payload.twaggon_id +
        '/tworkpackages/' +
        payload.twork_package_id +
        '/logentries',
        method: 'GET'
      })
      .then(resp => {
        commit('log_lists_success', {
          twork_package_id: payload.twork_package_id,
          log_lists: resp.data.data
        });
        commit('log_list_loading', false);
        })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('log_list_loading', false);
      });
  }
};
// Mutations
const mutations = {
  set_error(state, err) {
    state.error = err;
  },
  log_list_loading(state, loading) {
    state.loading = loading;
  },
  log_lists_success(state, payload) {
    Vue.set(state.log_lists, payload.twork_package_id, [...payload.log_lists]);
  },
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
